/**
 * 요금제 액션 타입
 * prefix: RealWorld.ActionTypes.*
 */
export enum ActionType {
  Dummy = 'Dummy',
  Text = 'Text',
  DirectionSequence = 'DirectionSequence',
  Password = 'Password',
  Button = 'Button',
  WebView = 'WebView',
  AR = 'AR',
  QR = 'QR',
  FrameShot = 'FrameShot',
  Nfc = 'Nfc',
  GpsRadar = 'GpsRadar',
  ColorFilter = 'ColorFilter',
  CameraOverlap = 'CameraOverlap',
  FrameShotV2 = 'FrameShotV2',
  GpsMap = 'GpsMap',
  ImageDetection = 'ImageDetection',
  ImageDetectionScratch = 'ImageDetection.Scratch',
}

/**
 * 액션 타입별 표시 텍스트
 */
export const ACTION_TYPE_LABELS: Record<ActionType, string> = {
  [ActionType.Dummy]: '액션 없음',
  [ActionType.Text]: '텍스트 입력',
  [ActionType.DirectionSequence]: '방향 입력',
  [ActionType.Password]: '4자리 비밀번호 입력',
  [ActionType.Button]: '버튼 클릭',
  [ActionType.WebView]: '웹뷰 페이지 활용',
  [ActionType.AR]: '[카메라] AR 이미지 인식',
  [ActionType.QR]: '[카메라] QR 코드 인식',
  [ActionType.FrameShot]: '[카메라] 프레임 사진 촬영',
  [ActionType.Nfc]: '[NFC] NFC 태그 인식',
  [ActionType.GpsRadar]: '[GPS] 특정 장소로 이동',
  [ActionType.ColorFilter]: '[카메라] 컬러 필터 렌즈',
  [ActionType.CameraOverlap]: '[카메라] 오버랩',
  [ActionType.FrameShotV2]: '다기능 프레임 사진 촬영',
  [ActionType.GpsMap]: '[GPS] 특정 여러 장소로 이동',
  [ActionType.ImageDetection]: '[카메라] 이미지 비교',
  [ActionType.ImageDetectionScratch]: '[카메라] 스크래치 이미지 비교',
};

/**
 * 액션 타입 분류
 */
export type ActionCategory = '기본' | '고급' | '추가';

export const ACTION_TYPE_CATEGORIES: Record<ActionType, ActionCategory> = {
  [ActionType.Dummy]: '기본',
  [ActionType.Text]: '기본',
  [ActionType.DirectionSequence]: '기본',
  [ActionType.Password]: '기본',
  [ActionType.Button]: '기본',
  [ActionType.WebView]: '기본',
  [ActionType.AR]: '고급',
  [ActionType.QR]: '고급',
  [ActionType.FrameShot]: '고급',
  [ActionType.Nfc]: '고급',
  [ActionType.GpsRadar]: '고급',
  [ActionType.ColorFilter]: '고급',
  [ActionType.CameraOverlap]: '고급',
  [ActionType.FrameShotV2]: '추가',
  [ActionType.GpsMap]: '추가',
  [ActionType.ImageDetection]: '추가',
  [ActionType.ImageDetectionScratch]: '추가',
};

/**
 * 전체 타입명 (prefix 포함)
 */
export const getFullActionTypeName = (actionType: ActionType): string => {
  return `RealWorld.ActionTypes.${actionType}`;
};

/**
 * 모든 액션 타입 목록
 */
export const ACTION_TYPES = Object.values(ActionType);
